<template>
  <div v-loading="loading" class="dialog-edit">
    <el-form ref="productForm" class="filter-form-container" :inline="true" size="mini">
      <el-form-item label="存货分类">
        <el-select filterable v-model="yhOrderTestStartPo.heTongFenLei" placeholder="请选择" type="select" name="yhOrderTestStartPo.heTongFenLei" size="mini" datasource="valuesource" default-value="bigContractType" remote="true" clearable :style="{width:'100%'}" @change="yhOrderTestStartPoHeTongFenLeiChanged">
          <el-option v-for="item in selectDataOptions['bigContractType']" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="产品编码">
        <el-input v-model="conditions.productCode" />
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input v-model="conditions.productName" />
      </el-form-item>

    </el-form>
    <span>查询结果</span>
    <div class="btky-container-crud__body">
      <vxe-grid
        ref="gridOptions_table"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="240"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions_table.gridOptions.columns"
        :data="gridOptions_table.gridOptions.data"
      >
        <template
          v-if="gridOptions_table.buttons && gridOptions_table.buttons.length > 0"
          #form
        >
          <el-form class="form-btns">
            <el-button
              v-for="btn in gridOptions_table.buttons"
              :key="btn.label"
              @click="tableEventButton(btn)"
            >{{ btn.label }}</el-button>
          </el-form>
        </template>
        <template
          v-for="item in gridOptions_table.gridOptions.columns"
          #[item.field]="{ row }"
        >
          <div :key="item.field">
            <el-input
              v-if="gridOptions_table.columnsFieldTypes[item.field] == 'input'"
              v-model="row[item.field]"
            />
            <el-select
              v-else-if="gridOptions_table.columnsFieldTypes[item.field] == 'select'"
              v-model="row[item.field]"
              placeholder="请选择"
            >
              <el-option
                v-for="selectItem in gridOptions_table.fields.options"
                :key="selectItem.val"
                :label="selectItem.label"
                :value="selectItem.val"
              />
            </el-select>
            <el-switch
              v-else-if="gridOptions_table.columnsFieldTypes[item.field] == 'switch'"
              v-model="row[item.field]"
            />
            <el-radio-group
              v-else-if="gridOptions_table.columnsFieldTypes[item.field] == 'radio'"
              v-model="row[item.field]"
            >
              <el-radio
                v-for="selectItem in gridOptions_table.fields.options"
                :key="selectItem.val"
                :label="selectItem.val"
              >{{ selectItem.label }}</el-radio>
            </el-radio-group>
            <el-checkbox-group
              v-else-if="gridOptions_table.columnsFieldTypes[item.field] == 'checkbox'"
              v-model="row[item.field]"
            >
              <el-checkbox
                v-for="selectItem in gridOptions_table.fields.options"
                :key="selectItem.val"
                :label="selectItem.val"
              >{{ selectItem.label }}</el-checkbox>
            </el-checkbox-group>
            <!-- <el-checkbox v-else-if="gridOptions_table.columnsFieldTypes[item.field] == 'checkbox'" v-model="row[item.field]">备选项</el-checkbox> -->
            <span v-else>{{ row[item.field] }}</span>
          </div>
        </template>
      </vxe-grid>
    </div>
    <!--分页 或底部 自定义底部-->
    <div ref="btkyCrudFooter" class="btky-container-crud__footer">
      <Pagination :pagination="pagination" @pagination-change="handleTablePaginationChange" />
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { query } from '@/api/platform/public/productSelect'
import ActionUtils from '@/utils/action'

// 接口入口
// const apiUpdateUserInfo = null

export default {
  props: {
    agents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      conditions: {
        productCode: '',
        productName: ''
      },
      yhOrderTestStartPo: { heTongFenLei: '' },
      selectDataOptions: {},
      loading: false,
      gridOptions_table: {
        default_value_type: 'fixed',
        required: false,
        hide_rights: false,
        read_rights: false,
        tableData: 'wlyContractPo',
        mode: 'block',
        buttons: [
          {
            label: '查询',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] },
            is_layout: true,
            funcId: '903342187591237632',
            eventJs: '{\n}\n',
            methodName: 'queryData',
            methodDesc: '查询',
            paramPoList: [
              {
                pk: '',
                name: 'row',
                ip: '192.168.9.34',
                createBy: '1',
                createTime: '2021-10-28 17:59:21',
                updateBy: null,
                updateTime: null,
                tenantId: null,
                dataStatus: null,
                dbType: null,
                id: '903342188765642752',
                eventId: '903342187591237632',
                type: 'in',
                order: null,
                remark: null
              }
            ],
            svrList: {},
            showList: []
          },
          {
            label: '重置',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ],
        colspan: 4,
        summary: false,
        sum_text: '',
        summary_method: false,
        gridOptions: {
          border: false,
          highlightHoverRow: true,
          resizable: true,
          showOverflow: true,
          height: 'auto',
          maxHeight: '240',
          align: 'center',
          size: 'mini',
          emptyText: '暂时没数据',
          columns: [
            { type: 'checkbox', title: 'id', filed: 'checkbox', width: 120 },
            {
              field: 'name',
              title: '产品名称',
              slots: { default: 'name' },
              editRender: { name: 'input' }
            },
            {
              field: 'code',
              title: '产品编号',
              slots: { default: 'code' },
              editRender: { name: 'input' }
            },
            {
              field: 'cunHuoFenLei',
              title: '存货分类',
              slots: { default: 'cunHuoFenLei' },
              editRender: { name: 'input' }
            },
            {
              field: 'pingPai',
              title: '品牌',
              slots: { default: 'pingPai' },
              editRender: { name: 'input' }
            },
            {
              field: 'guiGeXingHao',
              title: '规格型号',
              slots: { default: 'guiGeXingHao' },
              editRender: { name: 'input' }
            },
            {
              field: 'danWei',
              title: '单位',
              slots: { default: 'danWei' },
              editRender: { name: 'input' }
            }
          ],
          data: [
            { chanPinMingCheng: '五粮液1812', Pai: '五粮液', danWei: '件' },
            { chanPinMingCheng: '五粮液1818', pingPai: 'sdsd', danWei: '瓶' }],
          editConfig: { trigger: 'click', mode: 'cell' }
        },
        columnsField: 'chanPinMingCheng',
        columnsFields: {
          default: {
            datasource: 'custom',
            defaultVal: '',
            options: [
              { val: '1', label: '选项一', checked: false },
              { val: '2', label: '选项二', checked: false }
            ]
          }
        },
        columnsFieldTypes: { default: '' },
        fieldsEdit: {
          default: false,
          cunHuoFenLei: false,
          '': false,
          chuangJianRen: false,
          heTongMingCheng: false
        },
        fields: {
          datasource: 'custom',
          defaultVal: '',
          options: [
            { val: '1', label: '选项一', checked: false },
            { val: '2', label: '选项二', checked: false }
          ]
        },
        display: true,
        init_query: 'N',
        need_page: 'Y',
        page_size: 20
      }
    }
  },
  computed: {
  },
  created() {
    this.getSelectDictDataOrigin('bigContractType')
    if (this.queryData) {
      this.queryData()
    }
  },
  methods: {
    queryData() {
      const formData = new FormData()
      formData.append('productCode', this.conditions.productCode)
      formData.append('productName', this.conditions.productName)
      formData.append('id', 'sdfsdf3200003')
      formData.append('page', '1')
      formData.append('pagesize', '5')
      console.log(formData.id)
      const formData1 = 'sdfsdff232222'
      this.loading = true
      query(formData1).then(response => {
        this.loading = false
        console.log(response)
        this.gridOptions_table.gridOptions.data = response.data.Rows
      }).catch(() => {
        this.loading = false
      })
    },
    // 处理分页事件table
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      if (this.queryData) {
        this.queryData()
      }
    },
    tableEventButton(btn) {
      switch (btn.label) {
        case '查询':
          this.queryData()
          break
        case '重置':
          alert(21)
          // eslint-disable-next-line no-case-declarations,no-unused-vars
          const _selectData = this.$refs.gridOptions_table.getCheckboxRecords()[0]
          this.conditions.productCode = ''
          this.conditions.productName = ''
          break
        case '编辑':
          this.$refs.gridOptions_table.setActiveRow(
            this.$refs.gridOptions_table.getCheckboxRecords()[0]
          )
          break
        case '保存':
          this.$refs.gridOptions_table.clearActived().then(() => {})
          break
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData).then(response => {
        this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
      }).catch(() => { })
    },
    yhOrderTestStartPoHeTongFenLeiChanged(value) {
      this.$set(this['yhOrderTestStartPo'], 'heTongFenLei', value)
    },
    submitForm() {
      // const _selectData = this.$refs['productForm'].selection
      // console.log(_selectData)
      const _selectData = this.$refs.gridOptions_table.getCheckboxRecords()[0]
      console.log(_selectData)
      // 给父组件返回promise对象用于回调
      return new Promise((resolve) => {
      //  this.$refs['productForm'].validate(async(valid) => {
        // 表单验证情况
        // if (!valid) return false
        resolve(_selectData)

        // })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-edit {
  .title {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/public/productSelect.vue